import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import {LoadingBlockFields} from "../../../comum/components/LoadingBlockFields";
import Select from "react-select";
import {createSelectOptions, formatTelefone} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";
import {Alerta} from "../../../comum/components/Alerta";
import DatePicker from 'react-datepicker';
import moment from "moment";

@inject("store")
@observer
export class
DetalhamentoDadosMOT extends Component {

    static propTypes = {
        controller: PropTypes.object
    };

    constructor(props) {
        super(props);
    }

    render() {
        const ufs = ["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"]
        const ufOptions = ufs.map(uf => {return {value: uf, label: uf}});

        const tiposSanguineo = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
        const tipoSanguineoOptions = tiposSanguineo.map(tipoSanguineo => {return {value: tipoSanguineo, label: tipoSanguineo}});
        const controller = this.props.controller;
        const tarefa = controller.nomeTarefa;
        const dadosMot = controller.solicitacaoEtt.dadosMot;
        const permiteEditarCPF = controller.permiteEditarCPF;
        const isFormReadOnly = (tarefa !== "HT_ReivindicarConfirmar" && tarefa !== "HT_ReivindicarConfirmarIndicado") && !(tarefa === "HT_ConfirmarAlocacao");
        const isObrigatorio = tarefa === "HT_ConfirmarAlocacao";
        const obrigatorio = isFormReadOnly ? '' : (!isObrigatorio ? '' : <sup>*</sup> );
        const desabilitarValidacao = tarefa === "HT_ReivindicarConfirmar" ? true : _.get(this.props, "desabilitarValidacao", false);
        const exibeDadosExtraMOT = this.props.controller.exibeDadosExtraMOT;
        const obstrucaoValidacaoCPF = this.props.controller.obstrucaoValidacaoCPF;
        const alertaValidacaoCPF = this.props.controller.alertaValidacaoCPF;
        const permiteAlterarDatainicio = this.props.controller.tarefaPrecisaValidarMot();
        //RHFPP-998 - cadastro de genero
        const generos = ["MASCULINO", "FEMININO", "OUTROS", "NÃO DECLARADO"];
        const generoOptions = generos.map(genero =>{return{value: genero, label: genero}});

        return (
            <div>
                <h4>Dados da MOT</h4>
                <LoadingBlockFields carregando={controller.loadingCpfMOT}>
                    <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>CPF {obrigatorio}</Label>
                            <NumberFormat className="form-control" format="###.###.###-##"
                                          value={dadosMot.cpf}
                                          onChange={(event, values) => controller.setMotCpf(values.value)} readOnly={!permiteEditarCPF} />
                            {permiteEditarCPF && !desabilitarValidacao && <Validacao id="complementoCPF" valor={dadosMot.cpf} tipo={["isRequired", "isCPF"]} />}
                            {(permiteEditarCPF || permiteAlterarDatainicio) &&
                            <div>
                                {(obstrucaoValidacaoCPF && obstrucaoValidacaoCPF.length > 0) ? (
                                <Alerta id={"alertaCpfMOT"} alertas={obstrucaoValidacaoCPF} isBloqueante/>
                            ) : alertaValidacaoCPF && alertaValidacaoCPF.length > 0 &&
                                <Alerta id={"alertaCpfMOT"} alertas={alertaValidacaoCPF} isBloqueante={false}/>
                            }
                            </div>
                            }
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Nome completo {obrigatorio}</Label>
                            <Input type="text" maxLength={128} value={dadosMot.nome} onChange={(event) => controller.setNome(event.target.value)} readOnly={isFormReadOnly}/>
                            {!desabilitarValidacao && <Validacao id="complementoNome" valor={dadosMot.nome} tipo={["isRequired"]} />}
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Nome social</Label>
                            <Input type="text" maxLength={128} value={dadosMot.nomeSocial} onChange={(event) => controller.setNomeSocial(event.target.value)} readOnly={isFormReadOnly}/>
                        </FormGroup>
                    </Col>
                    {exibeDadosExtraMOT && !isFormReadOnly &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                        <Label>Data nascimento {obrigatorio}</Label>
                    <DatePicker
                        ref="dataNascimento"
                        onClickOutside={() => {
                        this.refs.dataNascimento.cancelFocusInput();
                        this.refs.dataNascimento.setOpen(false);
                    }}
                        locale={"pt_BR"}
                        readOnly={isFormReadOnly}
                        className="form-control"
                        dateFormat="DD/MM/YYYY"
                        selectsStart
                        selected={dadosMot.momentDataNascimento}
                        onChange={(value) => controller.setMomentDataNascimento(value)}
                        onBlur={(e) => controller.setDataNascimentoCheck(e.target.value)}/>
                    {!desabilitarValidacao && <Validacao id="dataNascimento" valor={dadosMot.dataNascimentoValidacao}
                        tipo={["isRequired", "isDate", "isIdadeValida"]}/>}
                    </FormGroup>
                    </Col>
                    }
                    {    exibeDadosExtraMOT && isFormReadOnly &&
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                            <Label>Data nascimento </Label>
                            <Input type="text" value={dadosMot.momentDataNascimento ? moment(dadosMot.momentDataNascimento).format("DD/MM/YYYY") : ""} readOnly/>
                            </FormGroup>
                        </Col>
                    }
                    {exibeDadosExtraMOT &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>E-mail {obrigatorio}</Label>
                            <Input type="text" maxLength={256} value={dadosMot.email} onChange={(event) => controller.setEmail(event.target.value)} readOnly={isFormReadOnly}/>
                            {!desabilitarValidacao && obrigatorio &&
                                <Validacao id="complementoEmail" valor={dadosMot.email} tipo={["isRequired", "isEmail"]} />
                            }
                        </FormGroup>
                    </Col>
                    }
                    {exibeDadosExtraMOT &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Telefone contato {obrigatorio}</Label>
                            <NumberFormat className="form-control" maxLength={11 + 4}
                                          format={(value) => formatTelefone(value)} value={dadosMot.telefone}
                                          onChange={(event, values) => controller.setTelefone(values.value)}
                                          readOnly={isFormReadOnly}/>
                            {!desabilitarValidacao && obrigatorio &&
                            <Validacao id="complementoContato" valor={dadosMot.telefone} tipo={["isRequired"]}/>
                            }
                        </FormGroup>
                    </Col>
                    }
                    {exibeDadosExtraMOT &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Identidade {obrigatorio}</Label>
                            <Input type="text" className="form-control" maxLength={11} value={dadosMot.identidade}
                                   onChange={(event) => controller.setIdentidade(event.target.value)}
                                   readOnly={isFormReadOnly}/>
                            {!isFormReadOnly && !desabilitarValidacao &&
                            <Validacao id="complementoIdentidade" valor={dadosMot.identidade} tipo={["isRequired"]}/>}
                        </FormGroup>
                    </Col>
                    }
                    {exibeDadosExtraMOT &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Orgão emissor {obrigatorio}</Label>
                            <Input type="text" maxLength={32} value={dadosMot.orgaoEmissor}
                                   onChange={(event) => controller.setOrgaoEmissor(event.target.value)}
                                   readOnly={isFormReadOnly}/>
                            {!isFormReadOnly && !desabilitarValidacao &&
                            <Validacao id="complementoOrgaoEmissor" valor={dadosMot.orgaoEmissor}
                                       tipo={["isRequired"]}/>}
                        </FormGroup>
                    </Col>
                    }
                    {exibeDadosExtraMOT &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Rua {obrigatorio}</Label>
                            <Input type="text" maxLength={256} value={dadosMot.endereco.rua}
                                   onChange={(event) => controller.setEnderecoRua(event.target.value)}
                                   readOnly={isFormReadOnly}/>
                            {!isFormReadOnly && !desabilitarValidacao &&
                            <Validacao id="complementoRua" valor={dadosMot.endereco.rua} tipo={["isRequired"]}/>}
                        </FormGroup>
                    </Col>
                    }
                    {exibeDadosExtraMOT &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Número</Label>
                            <Input type="number" min="1" onKeyPress={(event) => {return event.charCode >= 48 && event.charCode <= 57 ? '' : event.preventDefault()}} maxLength={8}
                                   value={dadosMot.endereco.numero} onChange={(event) => controller.setEnderecoNumero(event.target.value)} readOnly={isFormReadOnly}/>
                        </FormGroup>
                    </Col>
                    }
                    {exibeDadosExtraMOT &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Complemento</Label>
                            <Input type="text" maxLength={256} value={dadosMot.endereco.complemento} onChange={(event) => controller.setEnderecoComplemento(event.target.value)} readOnly={isFormReadOnly}/>
                        </FormGroup>
                    </Col>
                    }
                    {exibeDadosExtraMOT &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Bairro {obrigatorio}</Label>
                            <Input type="text" maxLength={128} value={dadosMot.endereco.bairro} onChange={(event) => controller.setEnderecoBairro(event.target.value)} readOnly={isFormReadOnly}/>
                            {!isFormReadOnly && !desabilitarValidacao && <Validacao id="complementoBairro" valor={dadosMot.endereco.bairro} tipo={["isRequired"]} />}
                        </FormGroup>
                    </Col>
                    }
                    {exibeDadosExtraMOT &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Cidade {obrigatorio}</Label>
                            <Input type="text" maxLength={128} value={dadosMot.endereco.cidade} onChange={(event) => controller.setEnderecoCidade(event.target.value)} readOnly={isFormReadOnly}/>
                            {!isFormReadOnly && !desabilitarValidacao && <Validacao id="complementoCidade" valor={dadosMot.endereco.cidade} tipo={["isRequired"]} />}
                        </FormGroup>
                    </Col>
                    }
                    {exibeDadosExtraMOT &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>CEP {obrigatorio}</Label>
                            <NumberFormat className="form-control" format="#####-###" value={dadosMot.endereco.cep} onChange={(event, values) => controller.setCEP(values.value)} readOnly={isFormReadOnly}/>
                            {!isFormReadOnly && !desabilitarValidacao && <Validacao id="complementoCEP" valor={dadosMot.endereco.cep} tipo={["isRequired"]} />}
                        </FormGroup>
                    </Col>
                    }
                    {exibeDadosExtraMOT &&
                    <Col xs={6} md={2} lg={2}>
                        <FormGroup>
                            <Label>UF {obrigatorio}</Label>
                            {isFormReadOnly ? (
                                <Input type="text" value={dadosMot.endereco.uf} readOnly />
                            ) : (
                            <Select value={dadosMot.endereco.uf} options={ufOptions}
                                    onChange={(value) => controller.setEnderecoUF(value)}
                                    noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                    multi={false}/>
                            )}
                            {!isFormReadOnly && !desabilitarValidacao && <Validacao id="complementoUF" valor={dadosMot.endereco.uf} tipo={["isRequired"]} />}
                        </FormGroup>
                    </Col>
                    }
                    {exibeDadosExtraMOT &&
                    <Col xs={6} md={2} lg={2}>
                        <FormGroup>
                            <Label>Tipo sanguíneo {obrigatorio}</Label>
                            {isFormReadOnly ? (
                                <Input type="text" value={dadosMot.tipoSanguineo} readOnly />
                            ) : (
                                <Select value={dadosMot.tipoSanguineo} options={tipoSanguineoOptions}
                                        onChange={(value) => controller.setTipoSanguineo(value)}
                                        noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                        multi={false}/>
                            )}

                            {!isFormReadOnly && !desabilitarValidacao && <Validacao id="complementoTipoSanguineo" valor={dadosMot.tipoSanguineo} tipo={["isRequired"]} />}
                        </FormGroup>
                    </Col>
                    }
                    {exibeDadosExtraMOT &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Gênero{obrigatorio}</Label>
                            {isFormReadOnly ? (
                                <Input type="text" value={dadosMot.genero} readOnly />
                            ) : (
                                <Select value={dadosMot.genero} options={generoOptions}
                                        onChange={(value) => controller.setGenero(value)}
                                        noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                        multi={false}/>
                            )}
                            {!isFormReadOnly && !desabilitarValidacao && <Validacao id="complementoGenero" valor={dadosMot.genero} tipo={["isRequired"]} />}
                        </FormGroup>
                    </Col>
                    }
                </Row></LoadingBlockFields>
            </div>
        )
    }
}